import { useEffect } from "react";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "./config";

// Nastaví / aktualizuje <meta> tag podľa atribútu a hodnoty.
const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Produkčná doména sa indexuje; preview / lokálne domény dostanú noindex.
const computeRobots = () => {
  const h = typeof window !== "undefined" ? window.location.hostname : "";
  const isPreview =
    h.includes("emergent") || h.includes("localhost") || h.endsWith(".local");
  return isPreview ? "noindex, nofollow" : "index, follow, max-image-preview:large";
};

/**
 * SEO komponent – nastavuje title, description, canonical, OG/Twitter a JSON-LD.
 * @param {string} title
 * @param {string} description
 * @param {string} path  cesta stránky (napr. "/program")
 * @param {string} image OG obrázok
 * @param {object|array} jsonLd  štruktúrované dáta (jedno alebo pole)
 */
const Seo = ({ title, description, path = "/", image = DEFAULT_OG_IMAGE, jsonLd }) => {
  useEffect(() => {
    const canonical = `${SITE_URL}${path === "/" ? "" : path}` || SITE_URL;
    document.title = title;
    document.documentElement.setAttribute("lang", "sk");

    setMeta("name", "description", description);
    setMeta("name", "robots", computeRobots());
    setLink("canonical", canonical);

    // Open Graph
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", image);
    setMeta("property", "og:locale", "sk_SK");

    // Twitter / X
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    // JSON-LD (odstráni predchádzajúce pridané Seo komponentom)
    document
      .querySelectorAll('script[data-seo-jsonld="true"]')
      .forEach((n) => n.remove());
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      arr.forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-jsonld", "true");
        s.text = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
  }, [title, description, path, image, jsonLd]);

  return null;
};

export default Seo;
